import { ConfigFn } from '@config/types'

const config = (({ publication }) => {
  const scriptVersion = '8.36.3'
  return {
    jwPlayerVersion: scriptVersion,
    durationFormat: 'm:ss',
    durationFormatWithHours: 'H:mm:ss',
    shortVideoLengthThresholdInSeconds: 45,
    videoMetadataUrl: 'https://cdn.jwplayer.com/v2/media/',
    playerScript: `https://ssl.p.jwpcdn.com/player/v/${scriptVersion}/jwplayer.js`,
    seoPlayerId: publication === 'romandie' ? 'JZRCsdmR' : 'bnOE68px',
    // transparent 1x1 poster to improve LCP score
    transparentPoster:
      'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEAAAAALAAAAAABAAEAAAIBAAA=',
  } as const
}) satisfies ConfigFn

export default config
